import { createSetting } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import { deleteTask } from '@/api/point'


const IS_SHOW_OPTIONS = [
  { label: '不展示', value: '0' },
  { label: '展示', value: '1' },
]

export const pageSetting = (vm) => createSetting({
  search: [
    { name: '任务ID', key: 'crm_activity_id' },
    { name: '任务名称', key: 'task_name' },
    {
      name: '是否展示',
      key: 'item_type',
      type: 'select',
      options: IS_SHOW_OPTIONS
    },
  ],
  columns: [
    { name: '会员系统ID', key: 'crm_activity_id'},
    { name: '任务名称', key: 'task_name'},
    { name: '任务描述', key: 'task_description'},
    { name: '任务排序', key: 'task_sort'},
    { name: '是否展示', key: 'is_show', type: 'switch', render: (h, { row }) => {
      return h('span', {
        class: row.is_show ? 'text-success' : 'text-danger'
      }, row.is_show == '1' ? '展示' : '不展示')
    } }
  ],
  actions: [
    {
      name: '添加任务',
      slot: 'header',
      type: 'button',
      buttonType: 'primary',
      action: {
        handler: () => {
          vm.handleAddTask()
        }
      }
    },
    {
      name: '编辑',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: (row) => {
          const id = row[0].id
          vm.handleAddTask(id)
        }
      }
    },
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (row) => {
          await deleteTask({ id: row[0].id })
          vm.refresh()
        }
      }
    }
  ]
})
